import { useEffect, useMemo } from 'react'
import { useWatch } from 'antd/lib/form/Form'

import { projectModel, UserRoles } from '../constants/constant'

const useBillingRules = ({
  form,
  projectModelOptions,
  userRole,
  projectData,
}) => {
  // Watch fields
  const billingConfigs = useWatch('projectConfigurationDetails', form) || []
  const isMultiModelEnabled = useWatch('isMultiModelEnabled', form)

  const firstBillingModel = billingConfigs?.[0]?.projectModel
  const isMultipleBilling = billingConfigs.length > 1

  // Force disable multi-model if first is Mixed
  useEffect(() => {
    if (firstBillingModel === projectModel.MIXED) {
      form.setFieldValue('isMultiModelEnabled', false)
    }
  }, [firstBillingModel, form])

  // Filter Project Model Options
  const filteredProjectModelOptions = useMemo(() => {
    return projectModelOptions
      ?.filter((option) => {
        if (
          isMultiModelEnabled &&
          isMultipleBilling &&
          option === projectModel.MIXED
        ) {
          return false
        }
        return true
      })
      ?.map((option) => ({
        label: option,
        value: option,
      }))
  }, [projectModelOptions, isMultiModelEnabled, isMultipleBilling])

  // ✅ Disable Add Billing Button
  const isAddBillingDisabled = useMemo(() => {
    const billingCount = billingConfigs?.length || 0
    const multiModelAllowed =
      userRole === UserRoles.ADMIN
        ? isMultiModelEnabled
        : projectData?.isMultiModelEnabled

    return (
      billingCount >= 1 &&
      (!multiModelAllowed || firstBillingModel === projectModel.MIXED)
    )
  }, [
    userRole,
    billingConfigs,
    isMultiModelEnabled,
    projectData,
    firstBillingModel,
  ])

  // Disable Multi Model Toggle
  const isMultiModelToggleDisabled = firstBillingModel === projectModel.MIXED

  return {
    filteredProjectModelOptions,
    isAddBillingDisabled,
    isMultiModelToggleDisabled,
    firstBillingModel,
    isMultipleBilling,
  }
}

export default useBillingRules
